var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { buildURI, useFetch } from '@hn-front/utils';
import pluralize from 'pluralize';
import { format, parseISO } from 'date-fns';
import { styled } from 'styled-components';
import { minsToHours } from '../../utils';
import { ACTIVITY_STREAM_API } from '../../constants/routes';
var ScStruggle = styled.span.withConfig({ displayName: "ScStruggle", componentId: "sc-9427h1" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
});
var useAssignmentsStreamData = function (_a) {
    var requestParams = _a.requestParams, _b = _a.shouldRequestAssignments, shouldRequestAssignments = _b === void 0 ? true : _b;
    var _c = useFetch(shouldRequestAssignments
        ? getStudentAssignmentsStreamUrl(requestParams)
        : undefined, { adapter: transformAssignmentsStreamData }), response = _c.response, rest = __rest(_c, ["response"]);
    return [response, rest];
};
var transformAssignmentsStreamData = function (data) {
    var summary = getSummaryTitleForAssignments(data);
    var assignments = data.assignments.map(function (assignment) {
        return (__assign(__assign({}, assignment), { cards: assignment.cards.map(function (card) { return (__assign(__assign({}, card), { startDate: card.startDate
                    ? format(parseISO(card.startDate), 'MMM d')
                    : null })); }) }));
    });
    return {
        summary: summary,
        struggleTasksCount: data.struggleTasksCount,
        assignments: assignments,
    };
};
var getSummaryTitleForAssignments = function (assignmentData) {
    var assignmentsCount = assignmentData.assignmentsCount, accuracy = assignmentData.accuracy, timeSpent = assignmentData.timeSpent, tasksCount = assignmentData.tasksCount, struggleTasksCount = assignmentData.struggleTasksCount;
    var _a = minsToHours(timeSpent), mins = _a.mins, hours = _a.hours;
    var hoursText = hours ? " " + hours + " h" : '';
    var minsText = '';
    if (mins)
        minsText = " " + mins + " min";
    else
        minsText = hours ? '' : ' < 1 min';
    var summary = (_jsxs("span", { children: [pluralize('assignment', assignmentsCount, true), ' (', pluralize('task', tasksCount, true), struggleTasksCount ? (_jsxs(_Fragment, { children: [', ', _jsxs(ScStruggle, { children: [struggleTasksCount, " struggle", ' ', pluralize('task', struggleTasksCount)] }, void 0)] }, void 0)) : (''), ') ', "| time spent:", hoursText, minsText, " | avg.accuracy: ", accuracy, "%"] }, void 0));
    return summary;
};
var getStudentAssignmentsStreamUrl = function (_a) {
    var studentId = _a.studentId, startDate = _a.startDate, endDate = _a.endDate, _b = _a.role, role = _b === void 0 ? 'teacher' : _b, schoolId = _a.schoolId;
    var supervizorParams = role === 'supervizor' ? { role: role, school_id: schoolId } : {};
    return buildURI(ACTIVITY_STREAM_API.assignmentsActivity, {
        pathParams: { studentId: studentId },
        query: __assign({ date: startDate, end_date: endDate }, supervizorParams),
    });
};
export { useAssignmentsStreamData };
var templateObject_1;
